import React from 'react'
import PropTypes from 'prop-types'
import { me } from '../../initial_state'
import SidebarSectionTitle from '../sidebar_section_title'
import SidebarSectionItem from '../sidebar_section_item'
import SidebarLayout from './sidebar_layout'
import { resizeImageUrl } from '../../utils/urls'
import { connect } from 'react-redux'
import { MODAL_PRO_UPGRADE } from '../../constants'
import { openModal } from '../../actions/modal'

class LoggedOutSidebar extends React.PureComponent {

  handleOnOpenProModal = () => {
    this.props.onOpenProModal('gs-los');
  }

  render() {
    const { title, showBackBtn, tabs } = this.props

    if (!!me) return null
   
    return (
      <SidebarLayout
        title={title}
        showBackBtn={showBackBtn}
        tabs={tabs}
      >
        <SidebarSectionTitle>Explore</SidebarSectionTitle>
        <SidebarSectionItem title='Home' icon='home' to='/' />
        <SidebarSectionItem title='Marketplace' icon='shop' to='/marketplace' />
        <SidebarSectionItem title='Groups' icon='group' to='/groups' />
        <SidebarSectionItem title='Feeds' icon='list' to='/feeds' />
        <SidebarSectionItem title='News' icon='news' to='/news' />
        <SidebarSectionItem title='About' icon='list' to='/about' />

        <SidebarSectionTitle>Popular</SidebarSectionTitle>
        <SidebarSectionItem to='/groups/158' isGroup showVerifiedGroup title='Classic Cars' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/000/158/original/79E5B15F-FCD3-4FA7-B473-4308CC89A67E.png', '40px')} />
        <SidebarSectionItem to='/groups/71172' isGroup showVerifiedGroup title="Gab's Gym Gains" image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/071/172/original/26f448975c77903a.png', '40px')} />
        <SidebarSectionItem to='/groups/9491' isGroup showVerifiedGroup title='Buy American Made' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/009/491/original/DD462BE2-70A1-4DBF-A3AF-5E1845000644.jpeg', '40px')} />
        <SidebarSectionItem to='/groups/61774' isGroup showVerifiedGroup title='Handmade Market' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/061/774/original/9CE4C0F1-D1DC-409E-BB53-AA4840DBD8EE.png', '40px')} />
        <SidebarSectionItem to='/groups/4992' isGroup showVerifiedGroup title='Aesthetics' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/004/992/original/EcwIG7wWoAQXei9.png', '40px')} />
        <SidebarSectionItem to='/groups/547' isGroup showVerifiedGroup title='Cooking' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/000/547/original/4a6a9d894a52db55.png', '40px')} />
        <SidebarSectionItem to='/groups/18' isGroup showVerifiedGroup title='Gardening' image={resizeImageUrl('https://media.gab.com/system/groups/cover_images/000/000/018/original/e2d0f8d445fc1a2f.jpg', '40px')} />

        <SidebarSectionTitle>Menu</SidebarSectionTitle>
        <SidebarSectionItem title='Gab AI' icon='ai-robot' href='https://gab.ai?f=gs-los' />
        <SidebarSectionItem title='Gab PRO' icon='pro' onClick={this.handleOnOpenProModal} />
        <SidebarSectionItem title='Gab Shop' icon='shop' href='https://shop.dissenter.com?f=gs-los' />
        <SidebarSectionItem title='Gab News' icon='news' href='https://news.gab.com' />
        <SidebarSectionItem title='Gab Voice' icon='audio' href='https://voice.gab.com' />
        <SidebarSectionItem title='Gab Trends' icon='trends' href='https://dissenter.com' />
        <SidebarSectionItem title='Gab Mobile App' icon='share' href='https://help.gab.com/article/gab-mobile-app' />
        <SidebarSectionItem title='Uncensored Image Generator' icon='ai-robot' href='https://gab.ai/start/gabby?f=gs-los' />
      </SidebarLayout>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  onOpenProModal(subtitle) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  },
})

LoggedOutSidebar.propTypes = {
  title: PropTypes.string,
  showBackBtn: PropTypes.bool,
  tabs: PropTypes.array,
}

export default connect(null, mapDispatchToProps)(LoggedOutSidebar)